import { numTicketConstants } from '../constants';
import { NumTicketsI } from '../models/NumTickets';

interface NumTicketsStoreState {
  isLoading: boolean;
  numTicket: null | NumTicketsI;
}

const initialState: NumTicketsStoreState = {
  isLoading: false,
  numTicket: null,
};

export const numTickets = (
  state = initialState,
  action: { type: string; payload: any },
) => {
  switch (action.type) {
    case numTicketConstants.NUMTICKET_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case numTicketConstants.NUMTICKET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        numTicket: action.payload.data,
      };
    case numTicketConstants.NUMTICKET_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
